/**
 * Test ID utilities for Chart component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for ChartContainer
 * @param identifier - Chart identifier
 * @returns Test ID string
 */
export const setChartTestId = (identifier: string): string =>
  generateTestId("Chart", identifier.replace(/\s+/g, "-").toLowerCase());
